import React from 'react'
import aws from '../../images/aws.png'
import { ExternalLink } from '@labrav/react-components'
import type { CloudType } from '@labrav/common'
import { useStyles } from './RequirementsAction.styles'

export interface RequirementsActionProps {
  link: string
  cloudType?: CloudType
  linkText?: string
  showCloudImg?: boolean
}

export const RequirementsAction: React.FC<RequirementsActionProps> = ({
  link,
  linkText,
  showCloudImg = true,
}) => {
  const { classes } = useStyles()
  return (
    <div className={classes.container} data-testid="requirements-button">
      {showCloudImg && (
        <img src={aws} className={classes.image} alt="AWS Image" />
      )}
      <ExternalLink href={link}>{linkText}</ExternalLink>
    </div>
  )
}
